import(/* webpackMode: "eager" */ "/vercel/path0/app/bus/[id]/page.tsx");
